module.exports = __webpack_public_path__ + "img/movie-img-1.85fcb2e7.png";